/** @typedef {import('./Props').default} Props */

import { translate } from '../../../Internationalization';
import BaseTable from '../../../../shared/BaseTable';
import getVendorsTableData from './vendorsTableData';
import getVendorsTableHeader from './getVendorsTableHeader';
import images from '../../../../config/local/images';
import Loading from '../../../../shared/Loading';
import NoContent from '../../../../shared/NoContent';
import React, { useCallback } from 'react';
import TableButton from '../../../../shared/TableButton';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function VendorsTable(props) {
	if (props.isGettingData) {
		return <Loading />;
	}

	if (!props.vendors?.length) {
		return (
			<NoContent message={props.emptyMessage} title={props.emptyTitle} />
		);
	}

	/**
	 * @param {string} id
	 * @returns {JSX.Element}
	 */
	function addEditButton(id) {
		const { editPath: pathname, editState, isGeneric } = props;

		return (
			<div className="w-fit mx-1">
				<TableButton
					disabled={isGeneric}
					icon={images.icons.edit}
					to={
						!isGeneric && {
							pathname,
							state: {
								...editState,
								offerId: id,
							},
						}
					}
				/>
			</div>
		);
	}

	const tableData = useCallback(
		() => getVendorsTableData(props.vendors, addEditButton),
		[props.vendors]
	);

	return (
		<BaseTable
			bodyData={tableData()}
			errorMessage={translate('agent.pages.offers.view.no_data')}
			headerData={getVendorsTableHeader()}
		/>
	);
}

export default React.memo(VendorsTable);
